import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CourseCarouselItem from '../CourseCarouselItem';
import Flickity from 'flickity';

class CourseCarousel extends Component {
  initFlickity () {
    const flickityOptions = {
      autoPlay: 10000,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      cellAlign: 'center',
      initialIndex: 4
    };
    this.flkty = new Flickity(this.courseCarousel, flickityOptions);
  }

  componentDidUpdate () {
    this.initFlickity();
  }

  render () {
    const items = this.props.courses.map((course) => {
      return <CourseCarouselItem course={course} key={course.id} />;
    });
    return (
      <section className='highlighted-section highlighted-section--dark courses-spotlight'>
        <div className='l-container'>
          <h2 className='split-heading alpha'>
            We've got the perfect course for you
            <strong>From complete beginner to professional interpreter</strong>
          </h2>
        </div>
        <div ref={(input) => { this.courseCarousel = input; }} className='course-card-list js-carousel js-inview is-inview'>
          {items}
        </div>
        <div className='l-container'>
          <Link to={'/get-started'} className='button button--l button--shadow'>
            Pick a course<span className='extra'> and start learning</span> now
          </Link>
          <br />
          <Link to={'/courses'} className='cta-additional-action'>
            View all courses
          </Link>
        </div>
      </section>
    );
  }
}

CourseCarousel.propTypes = {
  courses: PropTypes.array
};

export default CourseCarousel;



// WEBPACK FOOTER //
// ./src/components/CourseCarousel/index.js